import { Component } from '@angular/core';

@Component({
  selector: 'app-academic-footers',
  templateUrl: './academic-footers.component.html',
  styleUrls: ['./academic-footers.component.scss']
})
export class AcademicFootersComponent {

}
